var _defs, _rect, _rect2, _rect3, _text, _text2, _text3, _text4, _text5, _rect4, _text6, _text7, _text8, _text9, _rect5, _text0, _text1, _path, _rect6, _text10, _text11, _rect7, _text12, _text13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLookMenuBlender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 260",
    width: 620,
    height: 260,
    role: "img",
    "aria-label": "Blender's File menu open on Export, with a Squarebit Eye Look entry accepting .json and .usda.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .panel { fill: #11151c; }\n      .bar   { fill: #1b212b; }\n      .menu  { fill: #232b37; }\n      .hl    { fill: #22d3ee; fill-opacity: 0.14; }\n      .txt   { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 13px; fill: #cbd5e1; }\n      .dim   { fill: #64748b; }\n      .accent{ fill: #22d3ee; }\n      .label { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 11px; fill: #64748b; letter-spacing: .04em; }\n      .div   { stroke: #334155; stroke-width: 1; }\n      .arrow { stroke: #64748b; stroke-width: 1.2; fill: none; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 620,
    height: 260,
    rx: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bar",
    x: 12,
    y: 12,
    width: 596,
    height: 30,
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 20,
    y: 16,
    width: 42,
    height: 22,
    rx: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 30,
    y: 32
  }, "File")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 80,
    y: 32
  }, "Edit")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 122,
    y: 32
  }, "Render")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 180,
    y: 32
  }, "Window")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 242,
    y: 32
  }, "Help")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "menu",
    x: 20,
    y: 48,
    width: 180,
    height: 120,
    rx: 8
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 36,
    y: 72
  }, "New")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 36,
    y: 96
  }, "Open\u2026")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 36,
    y: 120
  }, "Import")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 176,
    y: 120
  }, "\u203A")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 28,
    y: 130,
    width: 164,
    height: 24,
    rx: 4
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 36,
    y: 147
  }, "Export")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 176,
    y: 147
  }, "\u203A")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow",
    d: "M196 142 L214 142"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "menu",
    x: 216,
    y: 106,
    width: 286,
    height: 96,
    rx: 8
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 232,
    y: 130
  }, "Collada (.dae)")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 232,
    y: 154
  }, "Universal Scene Description (.usd*)")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 224,
    y: 164,
    width: 270,
    height: 24,
    rx: 4
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 232,
    y: 181
  }, "Squarebit Eye Look (.json/.usda)")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 20,
    y: 230
  }, "File \u25B8 Import carries the same entry \u2014 the format is detected by content.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLookMenuBlender);
export default __webpack_public_path__ + "static/media/eye-look-menu-blender.f864dc81c81a2f5fa317c39b5a108041.svg";
export { ForwardRef as ReactComponent };